import { calculatePercentage } from '../calculatePercentage';

const safeCalculatePercentage = <TDefaultValue = undefined>(
  partialValue: unknown,
  totalValue: unknown,
  defaultValue?: TDefaultValue,
): number | TDefaultValue | undefined => {
  if (typeof partialValue === 'number' && typeof totalValue === 'number') {
    return calculatePercentage(partialValue, totalValue);
  }

  return defaultValue;
};

export { safeCalculatePercentage };
